import { render, staticRenderFns } from "./WxLogin.vue?vue&type=template&id=c7c02e1e&"
import script from "./WxLogin.vue?vue&type=script&lang=js&"
export * from "./WxLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports